module.exports = __webpack_public_path__ + "img/help_drawer_large.497ae615.png";